import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=1f1e59a0&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./image.scss?vue&type=style&index=0&id=1f1e59a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e59a0",
  null
  
)

export default component.exports